// extracted by mini-css-extract-plugin
export const youtubePlayer = "YoutubePlayer__youtubePlayer__svbx-";
export const spinnerWrapper = "YoutubePlayer__spinnerWrapper__7GOrT";